// InstagramStories.tsx
import React, { useEffect } from 'react';
import './Ts.css';

const InstagramStories: React.FC = () => {
    useEffect(() => {
        const accessToken = 'IGQWRORmFEa3JzRWdBcThoTUYxa3p2anNCVTl2ZA0w2NUQ0b1R6WHBtbVFjYmpRSmJGNnluUDZAtclJpNjNMQUhIdC1iVkxkY3BLaDJ6S0NWUEd0eFBJY1RDQ2FTLVRrOVM4RjFwQkFsT2pEZAHpQWDltbEgwaWpQeFkZD';

        const fetchInstagramStories = async () => {
            try {
                const response = await fetch(`https://graph.instagram.com/v12.0/me/media?fields=id,media_type,media_url,thumbnail_url,permalink,timestamp&access_token=${accessToken}`);

                if (!response.ok) {
                    throw new Error('Failed to fetch Instagram stories');
                }

                const data = await response.json();

                const storiesContainer = document.getElementById('instagram-stories');

                if (storiesContainer) {
                    data.data.forEach((story: any) => {
                        const storyElement = document.createElement('div');

                        // Log the entire story object to the console for debugging
                        console.log('Instagram Story Object:', story);

                        // Access the correct properties based on the API response
                        const thumbnailUrl = story.thumbnail_url || story.media_url; // Use media_url if thumbnail_url is undefined
                        const permalink = story.permalink || '#'; // Use # as a fallback if permalink is undefined

                        storyElement.innerHTML = `
              <a href="${permalink}" target="_blank">
                <img src="${thumbnailUrl}" alt="Instagram Story">
              </a>
            `;

                        storiesContainer.appendChild(storyElement);
                    });
                }
            } catch (error) {
                console.error('Error fetching Instagram stories:', error);
            }
        };
        fetchInstagramStories();
    }, []); // Empty dependency array to run the effect only once on mount

    return (
        <div>

        </div>
    );
};

export default InstagramStories;
